<template>
  <!-- 风格12 -->
  <div class="v12-style" :style="getStyleContainerStyle()" @click="handleClick">
    <img class="header-bg" src="@/assets/img/style12/header_bg.png" v-if="!isMobile" />
    <div class="header-left" v-if="!isMobile">
      <div class="header-left-show-infos" v-if="currentScene">
        <div
          v-for="(item, index) in headerLeftInfo"
          :key="index"
          class="info-item"
          :style="{
            fontSize: $w_Ratio(12, $store) + 'px',
            filter: selectedLeftIndex === index ? 'brightness(1.2)' : 'none',
            opacity: selectedLeftIndex === index ? 1 : 0.8,
          }"
          @click="selectLeftItem(index)"
        >
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="header-middle" v-if="!isMobile">
      <div class="header-middle-filter"></div>
      <div
        class="header-ProjectName"
        :style="{
          fontSize: $w_Ratio(30, $store) + 'px',
        }"
      >
        <p>{{ $store.state.ProjectInfo.Name }}</p>
      </div>
    </div>
    <div class="header-right" v-if="!isMobile">
      <div class="header-right-show-infos" v-if="currentScene">
        <div
          v-for="(item, index) in headerRightInfo"
          :key="index"
          class="info-item"
          :style="{
            fontSize: $w_Ratio(12, $store) + 'px',
            filter: selectedRightIndex === index ? 'brightness(1.2)' : 'none',
            opacity: selectedRightIndex === index ? 1 : 0.8,
          }"
          @click="selectRightItem(index)"
        >
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- 手机 -->
    <img class="header-bg" src="@/assets/img/mobile/style12/header_bg.png" v-if="isMobile" />
    <div class="header-middle" v-if="isMobile">
      <div class="header-middle-filter"></div>
      <div
        class="header-ProjectName"
        :style="{
          fontSize: $w_Ratio(22, $store) + 'px',
          lineHeight: $h_Ratio(style.height - 16, $store) + 'px',
        }"
      >
        <p>{{ $store.state.ProjectInfo.Name }}</p>
      </div>
    </div>
  </div>
  <div
    class="right-icon"
    :style="getRightInfopStyle()"
    v-if="icon3?.iconUrl"
    @click.stop="handleJump(icon3?.url)"
  >
    <div>
      <img :src="icon3.iconUrl" alt="" />
    </div>
    <div class="right-name">
      {{ headerIcon3Name }}
    </div>
  </div>
  <!-- 手机端 -->
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'V12Style',
  components: {},
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      style: {
        height: 80,
      },
      timeString: '',
      dateString: '',
      cityName: '',
      city: '',
      humidity: '',
      temperature: '',
      weather: '',
      icon1: { isShowIcon: false, iconUrl: '', url: '' }, // 图标1
      icon2: { isShowIcon: false, iconUrl: '', url: '' }, // 图标2
      icon3: { isShowIcon: false, iconUrl: '', url: '' }, // 图标3
      headerIcon2Name: '', // 跳转图标2名称
      headerIcon3Name: '', // 跳转图标3名称
      headerIcon1Name: '', // 跳转图标1名称
      headerLon: '',
      headerLat: '',
      headerLeftInfo: [
        { name: '全部' },
        { name: '龙井沟景区' },
        { name: '独山革命旧址群' },
        { name: '横排头风景区' },
        { name: '林水寨景区' },
      ],
      headerRightInfo: [
        { name: '泉街' },
        { name: '锦成·文庙街' },
        { name: '小龙生态园' },
        { name: '九公寨景区' },
        { name: '...' },
      ],
      selectedLeftIndex: null, // 当前选中的左侧 item 索引
      selectedRightIndex: null, // 当前选中的右侧 item 索引
      currentScene: true,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function(val) {
        this.onConfigurationChange();
      },
    },
    ProjectInfo: {
      deep: true,
      handler: function(val) {
        if (
          val.CurrentScene.id == 'd6nVTsiMIaK4RbjO7BJk0' ||
          val.CurrentScene.id == '6a_qMfEnODhoauWOCHj49' ||
          val.CurrentScene.id == 'xtQWmP-Ez4-TcZQ-HVRsj' ||
          val.CurrentScene.id == 'q-ZHNsUySlMQKa3cqQzZ9' ||
          val.CurrentScene.id == 'WLQBL9sgINUfgyaQegnqo' ||
          val.CurrentScene.id == '62z-TP_hLI68EYga-j8YM' ||
          val.CurrentScene.id == 'dA0M9aZu324A82faAlmjH'
        ) {
          this.currentScene = false;
        } else {
          this.currentScene = true;
        }
      },
    },
  },
  created() {
    this.onConfigurationChange();
    this.autoGetTime();
  },
  mounted() {
    this.headerIcon2Name = this.Configuration.propertyData?.headerIcon2?.value?.name;
    this.headerIcon1Name = this.Configuration.propertyData?.headerIcon1?.value?.name;
    this.headerIcon3Name = this.Configuration.propertyData?.headerIcon3?.value?.name;
    this.headerLon = this.Configuration.propertyData?.headerLngLatData?.value?.lon;
    this.headerLat = this.Configuration.propertyData?.headerLngLatData?.value?.lat;
    this.isCall = this.Configuration.propertyData?.customerservice?.value;
    this.selectedLeftIndex = 0;
    console.log(this.isMobile, 'shfusyhihsihiguygu');
  },
  methods: {
    handleJump(url) {
      if (url) {
        window.open(url);
      } else {
        this.$ElMessage.warning('请配置地址！');
      }
      console.log('跳转地址', url);
    },
    selectLeftItem(index) {
      this.selectedLeftIndex = index;
      this.selectedRightIndex = null; // 取消右侧的选中
    },
    selectRightItem(index) {
      this.selectedRightIndex = index;
      this.selectedLeftIndex = null; // 取消左侧的选中
    },
    toggleChartShow() {
      if (!this.isHideAllCharts) {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'hide',
          isAll: true,
        });
      } else {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'norm',
          isAll: true,
        });
      }
    },
    onConfigurationChange() {
      this.style.backgroundColor = this.Configuration.propertyData.headerBackgroundColor.value;
      this.cityName = this.Configuration.propertyData.cityName.value;
      this.icon1 = this.Configuration?.propertyData?.headerIcon1?.value;
      this.icon2 = this.Configuration?.propertyData?.headerIcon2?.value;
      this.icon3 = this.Configuration?.propertyData?.headerIcon3?.value;
      this.getWeather();
    },
    getWeather() {
      this.axios({
        method: 'get',
        url: `https://restapi.amap.com/v3/weather/weatherInfo?city=${this.cityName}&output=json&key=db5d2728c584e5884c385c2a509b29b9`,
        dataType: 'jsonp',
      })
        .then(res => {
          console.log(res, '位置 weatherUrl');
          if (res.status === 200) {
            if (!(res.data.lives[0] instanceof Array)) {
              let { humidity, temperature, weather, city, province } = res.data.lives[0];
              this.humidity = humidity;
              this.temperature = temperature;
              this.weather = weather;
              this.city = city;
              if ((this.headerLon, this.headerLat)) {
                let LonLat = this.headerLon + ',' + this.headerLat;
                LonLat = LonLat.replace(/\s*/g, ''); // 去除字符串里的空格
                return new Promise((resolve, reject) => {
                  this.axios({
                    method: 'get',
                    // 该接口为和风天气插件 生成接口
                    url: `https://devapi.qweather.com/v7/air/5d?location=${LonLat}&key=972802b2c6ea46a6bd275fa504584b5f`,
                    dataType: 'jsonp',
                  }).then(res => {
                    resolve(res);
                  });
                });
              }
            }
          }
        })
        .then(res => {
          console.log(res, '空气质量 zlUrl');
          if (res.status == 200) {
            // this.aqiName = '优';
            this.aqiName = res.data.daily[0].category;
          } else {
            this.$ElMessage.warning('获取信息失败！');
          }
        });
    },
    getHeaderInfopStyle(fs = 14, pt = 15) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
      };
    },
    getStyleContainerStyle() {
      return {
        height: this.$h_Ratio(this.style.height, this.$store) + 'px',
        backgroundColor: this.style.backgroundColor,
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    autoGetTime() {
      let padaDate = function(value) {
        // 时间不足十补零
        return value < 10 ? '0' + value : value;
      };
      setInterval(() => {
        const date = new Date();
        // console.log(date);
        const year = date.getFullYear(); //存储年
        const month = padaDate(date.getMonth() + 1); //存储月份
        const day = padaDate(date.getDate()); //存储日期
        const hours = padaDate(date.getHours()); //存储时
        const minutes = padaDate(date.getMinutes()); //存储分
        const seconds = padaDate(date.getSeconds()); //存储秒
        //返回格式化后的日期
        this.dateString = year + 'D' + month + 'D' + day;
        this.timeString = hours + 'T' + minutes + 'T' + seconds;
      }, 1000);
    },
  },
  computed: {
    ...mapState({
      isHideAllCharts: state => state.ProjectInfo.isHideAllCharts,
      isMobile: state => state.isMobile,
      pointList: state => state.pointList,
    }),
  },
  Configuration: {
    componentTitle: '旅数慧屏',
    componentName: 'V12Style',
    componentOverViewImg: './img/styles/style12.png',
    backgroundImg: './img/backgrounds/background_img/V12.png',
    backgroundImgMobile: `./img/backgrounds/background_img/mobile/V4.png`,
    propertyData: {
      cityName: {
        propertyComponentName: 'SingleInputor',
        value: '杭州',
        lable: '定位城市',
      },
      headerLngLatData: {
        propertyComponentName: 'MapLatLon',
        value: {
          lon: '120.15',
          lat: '30.28',
        },
      },
      headerBackgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        value: 'rgba(25, 36, 45, 0)',
        lable: '头部背景颜色',
      },
      menuStyle: {
        value: {
          height: 75,
          width: 700,
        },
      },
      headerIcon1: {
        propertyComponentName: 'HeaderIcon1Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
      headerIcon2: {
        propertyComponentName: 'HeaderIcon2Configer',
        value: {
          isShowIcon: false,
          iconUrl: '',
          url: '',
          name: '',
        },
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.v12-style {
  z-index: 99;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  color: #01f0f9;
  display: flex;

  justify-content: space-between;
  /* background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.765) 45%, transparent 100%); */
  .header-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
  .header-left {
    /* max-width: 654px; */
    width: 34%;
    height: 100%;
    position: relative;
    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .header-left-show-infos {
      width: 100%;
      height: 66%;
      position: absolute;
      top: 38%;
      display: flex;
      .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;

        height: 100%;
        color: #d8f0ff;
        background: url('../../../assets/img/bg_left.png') no-repeat;
        background-size: 100% 100%;
        opacity: 0.8;
        transition: opacity 0.3s ease, filter 0.3s ease;
      }
      .info-item:hover {
        opacity: 1;
        filter: brightness(1.2);
      }
    }
  }

  .header-middle {
    width: 30.5%;
    height: 100%;
    flex-shrink: 1;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .header-ProjectName {
      width: 100%;
      height: 100%;
      position: absolute;
      font-weight: 700;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #cfeaff;

      p {
        margin: 0;
        background: linear-gradient(to bottom, #ffffff 30%, #aad6e8 66%, #6ab7d6 100%);
        background-clip: text;
        -webkit-background-clip: text;
        color: transparent;
      }
    }
  }

  .header-right {
    width: 34%;
    height: 100%;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-right-show-infos {
      width: 34%;
      height: 66%;
      position: absolute;
      top: 38%;
      display: flex;
      .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;

        height: 100%;
        color: #d8f0ff;
        background: url('../../../assets/img/bg_right.png') no-repeat;
        background-size: 100% 100%;
        opacity: 0.8;
        transition: opacity 0.3s ease, filter 0.3s ease;
      }
      .info-item:hover {
        opacity: 1;
        filter: brightness(1.2);
      }
    }
  }
  .right-icon {
    z-index: 1000;
    background: #031943;
    position: absolute;
    right: 0;
    bottom: -900%;
    width: 26px;
    height: 80px;
    border-radius: 6px 0 0 6px;
    border-top: 1px solid #148ddd;
    border-bottom: 1px solid #148ddd;
    border-left: 1px solid #148ddd;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;
    .right-name {
      color: #fff;
      line-height: 28px;
      writing-mode: vertical-lr;
    }
    img {
      display: none;
    }
  }
}
.icon {
  margin-right: 25px;

  img {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
}
.icon2 {
  margin-left: 0;
}
</style>
